import React from 'react'

const FEATURES = [
  {
    icon: 'wand-sparkles',
    bg: 'var(--gradient-coral)',
    title: 'Formulation AutoPilot',
    body: "Tu ajoutes les ingrédients, l'AutoPilot équilibre la ration en temps réel. Chaque nutriment est mesuré, chaque ajustement instantané.",
    tags: ['FEDIAF', 'AAFCO', 'Littérature'],
  },
  {
    icon: 'package-search',
    bg: 'var(--gradient-navy)',
    title: "Base d'aliments industriels",
    body: "Plus de 30 indications thérapeutiques, tous fabricants confondus. Cherche par pathologie, par marque ou par nom — et intègre l'industriel dans une ration mixte.",
    tags: ['30+ indications', 'Tous fabricants'],
  },
  {
    icon: 'book-open',
    bg: 'linear-gradient(135deg, var(--sand-600), var(--sand-500))',
    title: "Bibliothèque d'ingrédients",
    body: "Viandes, légumes, compléments, huiles, CMV — chaque aliment est documenté avec ses apports par 100g. Tu construis ta ration à partir de données fiables.",
    tags: ['Ménager', 'Compléments', 'CMV'],
  },
  {
    icon: 'history',
    bg: 'linear-gradient(135deg, var(--green-600), var(--green-500))',
    title: 'Historique du patient',
    body: "Chaque animal garde un dossier nutritionnel. Retrouve ses rations passées, adapte-les quand il vieillit, change de poids ou de pathologie.",
    tags: ['Suivi long terme', 'Prescription PDF'],
  },
]

const Features = () => (
  <section className="vt-section cream" id="features">
    <div className="vt-shell">
      <div className="sec-head">
        <span className="eyebrow">Fonctionnalités</span>
        <h2>Tout ce qu'il faut, rien de trop.</h2>
        <p>Un outil clinique centré sur le rationnement — pas un ERP vétérinaire.</p>
      </div>
      <div className="fgrid">
        {FEATURES.map((f, i) => (
          <div className="fcell" key={i}>
            <div className="fcell__icon" style={{ background: f.bg }}>
              <i data-lucide={f.icon}></i>
            </div>
            <h3>{f.title}</h3>
            <p>{f.body}</p>
            <div className="fcell__meta">
              {f.tags.map((t, j) => (
                <span className="fcell__tag" key={j}>{t}</span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
)

export default Features
